import { useMsal } from "@azure/msal-react";
import React from 'react';
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { SOCAN_MEMBER_URL_BY_TYPE } from "../Consts";

interface AboutProps {
    type?: string;
    guid?: string;
    memberType?: number | string;
    client?: string;
}

export interface IMyFormsPageProps {   
    location?: { aboutProps?: AboutProps };
    powerPortalURL: string;
}

const getMemberFormPath = (client?: string, memberType?: number | string) => {
  if (client === "SOCAN") {
    return SOCAN_MEMBER_URL_BY_TYPE[memberType?.toString() ?? ""] ?? "membership-edit";
  }
  return "membership-edit";
};

const MyFormsPage = (props: IMyFormsPageProps) => {
    const { instance, accounts } = useMsal();
    const langMap: Record<string, string> = { "en-GB": "en-US", "fr": "fr-FR" };
    const storedPreferences = React.useMemo(() => {
        try {
            const raw = JSON.parse(localStorage.getItem('userLanguagePreferences') || '"en-US"');
            return langMap[raw] || raw;
        } catch {
            return 'en-US';
        }
    }, []);

    let powerPortalURL = props.powerPortalURL;
    let aboutProps = props.location?.aboutProps;

    if (!powerPortalURL) {
        const stored = sessionStorage.getItem('myFormsProps');
        if (stored) {
            const parsed = JSON.parse(stored);
            powerPortalURL = parsed.powerPortalURL || powerPortalURL;
            aboutProps = parsed.aboutProps || aboutProps;
        }
    }

    // Store preferences if props are present (organic visit)
    React.useEffect(() => {
        if (props.powerPortalURL) {
            const myFormsProps = {
                powerPortalURL: props.powerPortalURL,
                aboutProps: props.location.aboutProps,
            };
            sessionStorage.setItem('myFormsProps', JSON.stringify(myFormsProps));
        }
    }, [props.powerPortalURL, props.location?.aboutProps]);

    React.useEffect(() => {        
        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [instance, accounts])    

    React.useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 0);
    }, []);

    const { type, guid, memberType, client } = aboutProps || {};
    const memberUrl = getMemberFormPath(client, memberType);
    let frame;

    if (type === "new") {
        frame = <iframe src={`${powerPortalURL + "/" + storedPreferences + "/application-selection?lang=" + storedPreferences}`} style={{ width: '100%', height: '100vh' }} ></iframe>
    }
    else if (guid) {
        frame = <iframe src={`${powerPortalURL + "/" + storedPreferences + "/" + memberUrl + "?id=" + guid + "&lang=" + storedPreferences}`} style={{ width: '100%', height: '100vh' }} ></iframe>        
    }
    else {
        frame = <iframe src={`${powerPortalURL + "/" + storedPreferences + "/application-selection?lang=" + storedPreferences}`} style={{ width: '100%', height: '100vh' }} ></iframe>
    }

    return frame;
}

export default MyFormsPage;